export const getFilter = state => state.filter;
export const getContacts = state => state.contacts;
